"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunk64FNDIZXcjs = require('./chunk-64FNDIZX.cjs');


var _chunkFXL7SAQJcjs = require('./chunk-FXL7SAQJ.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_1/router/CPIRouterV2_1.ts
var CPIRouterV2_1 = (_class = class extends _chunkFXL7SAQJcjs.BaseRouterV2_1 {
  static __initStatic() {this.dexType = _chunkNE5AG7IWcjs.DEX_TYPE.CPI}
  async getPool(provider, params) {
    const poolAddress = await this.getPoolAddressByJettonMinters(
      provider,
      params
    );
    return _chunk64FNDIZXcjs.CPIPoolV2_1.create(poolAddress);
  }
}, _class.__initStatic(), _class);



exports.CPIRouterV2_1 = CPIRouterV2_1;
//# sourceMappingURL=chunk-DHMQIKTC.cjs.map